export const APPLICATION_TVA_TYPE = {
  normal: 'Normal',
  exportHorsUE: 'Export hors UE',
  intracommunautaire: 'Intracommunautaire',
  nonApplicable: 'Non applicable',
};
